import { render, staticRenderFns } from "./OmsForm.vue?vue&type=template&id=464abee0&scoped=true"
import script from "./OmsForm.vue?vue&type=script&lang=js"
export * from "./OmsForm.vue?vue&type=script&lang=js"
import style0 from "./OmsForm.vue?vue&type=style&index=0&id=464abee0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464abee0",
  null
  
)

export default component.exports